// src/onboarding/onboardingApi.ts
import { apiClient } from "@maat/api-base";
var onboardingApi = {
  getStatus: async () => {
    return apiClient.get("/main/api/onboarding/status");
  }
};

export {
  onboardingApi
};
